import {Component, Inject, Injector, OnInit, PLATFORM_ID} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {NavigationEnd, Router, RouterOutlet, TitleStrategy} from '@angular/router';
import {NgcCookieConsentService, NgcCookieConsentModule} from 'ngx-cookieconsent';
import { Store } from '@ngrx/store';
import {HeaderComponent} from "./component/header/header.component";
import {FooterComponent} from "./component/footer/footer.component";
import {RecaptchaModule} from "ng-recaptcha-19";
import {TemplatePageTitleStrategy} from "./strategy/template-page-title-strategy";
import * as GeoActions from './geo/action/geo.action';
import { selectIsRegulated } from './geo/selector/geo.selector';
import { filter } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    RouterOutlet,
    RecaptchaModule,
    NgcCookieConsentModule
  ],
  providers: [
    { provide: TitleStrategy, useClass: TemplatePageTitleStrategy },
    /**/
  ],
})
export class AppComponent implements OnInit {
  private ccService!: NgcCookieConsentService;
  private gtmInitialized = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private injector: Injector,
    private store: Store
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {

      // Debug: Check initial geo state
      this.store.select(selectIsRegulated).subscribe(isRegulated => {
        console.log('Current isRegulated value:', isRegulated);
      });

      // Dispatch action to check geo location (will use cache if available)
      console.log('Dispatching checkGeoLocation action');
      this.store.dispatch(GeoActions.checkGeoLocation());

      // Subscribe to geo location result
      this.store.select(selectIsRegulated).pipe(
        filter(isRegulated => isRegulated !== null)
      ).subscribe(isRegulated => {
        console.log('Geo location result:', isRegulated);
        if (!isRegulated) {
          console.log('Not regulated - initializing GTM');
          this.initGTM();
        } else {
          console.log('Regulated - showing cookie consent');
          this.initializeCookieConsent();
        }
      });
    }
  }

  private initializeCookieConsent() {
    try {
      this.ccService = this.injector.get(NgcCookieConsentService);

      // Check if user already consented (stored in localStorage by ngx-cookieconsent)
      if (this.ccService.hasConsented()) {
        this.initGTM();
        return;
      }

      this.ccService.statusChange$.subscribe(({ status }) => {
        if ((status === 'allow' || status === 'dismiss') && !this.gtmInitialized) {
          this.initGTM();
        }
      });
    } catch (error) {
      console.error('Error initializing cookie consent service:', error);
    }
  }

  private initGTM() {
    if (this.gtmInitialized) return;


    // Initialize dataLayer
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    // Inject GTM script
    this.injectGTMScript();

    // Track page views
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (window as any).dataLayer.push({
          event: 'pageView',
          pagePath: event.urlAfterRedirects
        });
      }
    });

    this.gtmInitialized = true;
  }

  private injectGTMScript() {
    const gtmId = 'GTM-KJDBNFQ';
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);
  }
}
